import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    return axios.get(process.env.API_ENDPOINT + '/pattern?token=' + VueCookies.get('token'))
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/pattern?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/pattern/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/pattern/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/pattern/' + id + '?token=' + VueCookies.get('token'))
  }
}



// WEBPACK FOOTER //
// ./src/store/api/patterns.js